import * as React from 'react'

import { Space } from '../../atoms'
import Icon from '../../atoms/Icon'
import { StyledBox, StyledIconWrapper, StyledSummary } from './accordion.styles'

export type AccordionProps = {
  children: React.ReactNode
  isExpanded: boolean
  onToggle: (isExpanded: boolean) => void
  summary: React.ReactNode
}

export function Accordion({ children, isExpanded, onToggle, summary }: AccordionProps) {
  const onToggleExpand = () => {
    onToggle(!isExpanded)
  }
  return (
    <StyledBox>
      <StyledSummary
        isflex
        alignContent="center"
        alignItems="center"
        flexDirection="row"
        isExpanded={isExpanded}
        px={5}
        py={4}
        onClick={onToggleExpand}
      >
        <StyledIconWrapper>
          <Icon name={isExpanded ? 'chevronRight' : 'chevronDown'} size="small" />
        </StyledIconWrapper>
        <Space flexGrow={1} mx={2}>
          {summary}
        </Space>
      </StyledSummary>
      {isExpanded && children}
    </StyledBox>
  )
}
